import { render } from "./MrsdExpressionViewer.vue?vue&type=template&id=645424fd&scoped=true"
import script from "./MrsdExpressionViewer.vue?vue&type=script&lang=js"
export * from "./MrsdExpressionViewer.vue?vue&type=script&lang=js"

import "./MrsdExpressionViewer.vue?vue&type=style&index=0&id=645424fd&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/RNAseq_web/prime_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645424fd"]])

export default __exports__